// Categorical palette for chart slices (colorblind-safe order, validated —
// adjacent-pair CVD deltaE >= 8 on a light surface). Do not reorder.
export const CHART_COLORS = [
  '#2a78d6',
  '#008300',
  '#e87ba4',
  '#eda100',
  '#1baf7a',
  '#eb6834',
  '#4a3aa7',
  '#e34948',
];

export const OTHER_COLOR = '#64748b';

export const MAX_SLICES = 7;

// Turn report rows into at most MAX_SLICES named slices plus an "Other"
// bucket, each with a palette color and its share of the total.
export function buildSlices(rows, getLabel, getId = (row, index) => index) {
  const withHours = rows.filter((row) => row.hours > 0);
  const total = withHours.reduce((sum, row) => sum + row.hours, 0);
  if (!total) return { slices: [], total: 0 };

  const sorted = [...withHours].sort((a, b) => b.hours - a.hours);
  const head =
    sorted.length > MAX_SLICES + 1 ? sorted.slice(0, MAX_SLICES) : sorted;
  const tail = sorted.slice(head.length);

  const slices = head.map((row, index) => ({
    id: String(getId(row, index)),
    label: getLabel(row),
    hours: row.hours,
    pct: (row.hours / total) * 100,
    color: CHART_COLORS[index],
  }));
  if (tail.length) {
    const hours = tail.reduce((sum, row) => sum + row.hours, 0);
    slices.push({
      id: 'other',
      label: `Other (${tail.length})`,
      hours,
      pct: (hours / total) * 100,
      color: OTHER_COLOR,
      items: tail.map((row, index) => ({
        id: String(getId(row, head.length + index)),
        label: getLabel(row),
        hours: row.hours,
        pct: (row.hours / total) * 100,
      })),
    });
  }
  return { slices, total };
}

// Aggregate the report's people rows into per-team rows shaped like the other
// report rows ({ ..., hours }) so buildSlices can consume them.
export function buildTeamRows(peopleRows) {
  return Object.values(
    peopleRows.reduce((acc, row) => {
      const key = row.user.teamId || 'none';
      acc[key] ||= {
        teamId: row.user.teamId,
        teamName: row.user.teamName || 'No team',
        hours: 0,
      };
      acc[key].hours += row.hours;
      return acc;
    }, {}),
  ).sort((a, b) => b.hours - a.hours);
}
